import { LivePreview } from './LivePreview';
import { ScannabilityInfo } from './ScannabilityInfo';
import { ExportBar } from './ExportBar';
import './RightPanel.css';

export const RightPanel: React.FC = () => {
  return (
    <div className="right-panel">
      <div className="right-panel-content">
        <LivePreview />
        <ScannabilityInfo />
        <ExportBar />
      </div>
    </div>
  );
};
